var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-container"},[_c('div',{staticClass:"guide-title font-default"},[_vm._v("Guide")]),_c('div',{staticClass:"feet"},[_c('div',{staticClass:"foot leftFoot"}),_c('div',{staticClass:"foot"})])])
}]

export { render, staticRenderFns }